
const MainContent = (props: any) => (
    <div className="main-content">
        {props.children}
    </div>
)

export default MainContent;
